module.exports = __webpack_public_path__ + "img/4.36cbf855.jpg";